// extracted by mini-css-extract-plugin
export default {"heading":"VersionControl_heading__l9LTe"};